<h4>Grundrabatt</h4>
<p>Det är en "buffert" som används för att garantera banken en minimumintjäning. Intjäning beräknas som listpris -
  produktionspris minus detta värde för respektive LTV</p>
<div class="save-item">
  <!-- see component for an explanation -->
  <spb-interest-input [value]="{p: service.discount}" [showSuffix]="true"/>
  <spb-save-button/>
</div>
<h4>Internränta privatlån</h4>
<p>Används för att beräkna intjäning på privatlån</p>
<div class="save-item">
  <spb-interest-input [value]="{p: service.internalInterestPrivateLoan}" [showSuffix]="true"/>
  <spb-save-button/>
</div>
<h4>Rabatt baserat på bindingstid</h4>
<p>Här sätts av en Ekonomi/Finans rabatt beroende på bindningstid. Dessa värden konfigureras och sparas.</p>
<spb-binding-discount [discounts]="service.bindingDiscounts()"/>
<spb-save-button/>
<h4>Simulator</h4>
<spb-simulator/>

<h4>Produktionspriser</h4>
<p>Dessa sätts manuellt av Ekonomi/Finans.</p>
<spb-production-price-table [interests]="service.productionPrices()"/>
<p>Tabellen nedan visar Internränta - Produktionspris - "Grundrabatt".</p>
<p>Genom att ändra grundrabatten så kommer alla värden att öka eller minska i motsvarande grad, varje punkt från 0,1
  (some är baseline) kommer att påverka värdet linjärt.</p>
<p>Vidare kan du justera "Rabatt för bindningstid", dvs du ändrar för t ex 3 mån att den rabatten skall vara n punkter
  högre. Det kommer då att förändra värdet för 3 mån.</p>
<p>Just nu räknar vi bara på l753, men om detta är i rätt riktning så kan man få välja produkt också. Men det är högst
  tveksamt om det är relevant.</p>
<spb-derived-table [interests]="service.productionPrices()"/>

<spb-save-button/>

<h4>Listräntor</h4>
<p>Dessa hämtas från l753 samt Borgo API. l754 och l756 har samma ränta som l753. Övriga räntor är +0,2 för l750,l752
  och l755 samt -0,1 för l751.</p>
<p>Du kan ändra dessa värden momentant men kan inte spara dem.</p>
<spb-interest-table [interests]="service.listInterests()"/>

<h4>Räntor för sparande</h4>
<spb-savings-interests [interests]="service.savingsInterests()"/>

